import { HttpHeaders } from "@angular/common/http";
import { Component, OnInit, HostBinding, Input, ChangeDetectionStrategy } from "@angular/core";

import { NbToastrService } from "@nebular/theme";
import { Imagen } from "app/dto/imagen.dto";
import { Siniestro } from "app/dto/siniestro.dto";
// import { TipoComprobanteImagenEnum } from "app/enums/tipo-comprobante-imagen.enum";
import { SiniestroService } from "app/service/siniestro.service";
import { StorageService } from "app/service/storage.service";
import { FieldConfig } from "../../field.interface";

@Component({
  selector: "app-fileUploader",
  template: `
      <div class="row" *ngIf="hidden()">
        <div class="col-12 p-0 mb-3">
          <div class="dropzone">
            <input type="file" #fileDropRef id="fileDropRef" multiple (change)="fileBrowseHandler($event.target.files)" /> 
            <label for="fileDropRef">{{field.label}}</label>  
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-left py-1 px-3 separador-item " *ngFor="let file of archivosSeleccionados; let i = index">
          <div class="row">
              <div class="col-5">
                  <p class="ml-1">{{file.name}}</p>
              </div>
              <div class="col-3 text-center" *ngIf="field.showExtraFunctions">
                <mat-select placeholder="Tipo de Dato"
                  (selectionChange)="changeType($event, file)">
                  <mat-option *ngFor="let field of tipoArchivos"
                    [value]="field">{{field.descripcion}}</mat-option>
                </mat-select>
              </div>
              <div class="col-2 text-center">
                <button mat-mini-fab color="primary" [disabled]="checkDisableUpload(field, file)" (click)="upload(file)" type="button" aria-label="Subir Archivo">
                  <mat-icon>upload</mat-icon>
                </button>
              </div>
              <div class="col-2 text-center">
                <button mat-mini-fab color="warn" (click)="delete(file)" type="button" aria-label="Eliminar Archivo">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
        </div>
      </div>

`,
  styleUrls: ["./file-uploader.component.scss"],
  changeDetection: ChangeDetectionStrategy.Default
})
export class FileUploaderComponent implements OnInit {
  field: FieldConfig;
  tipoArchivos: any[];
  archivosSeleccionados: any[];

  flgMuestroDrop: boolean = false;
  @Input() callback: (args: any) => void;
  currentUser: any;
  httpRequestHeaders:
    | HttpHeaders
    | {
      [header: string]: string | string[];
    } = new HttpHeaders();

  @HostBinding('class') class = '';


  constructor(
    private storageService: StorageService,
    private toastrService: NbToastrService
  ) {
    this.currentUser = JSON.parse(this.storageService.getItem('user'));
    this.httpRequestHeaders = new HttpHeaders()
      .set("Authorization", this.currentUser.token)
      .set("content-type", null);
  }

  ngOnInit() {
    // this.archivosSeleccionados = [];
    // this.tipoArchivos = Object.values(TipoComprobanteImagenEnum).map(x => { return { descripcion: x } });
    // this.class = this.field.claseGrillaBootstrap;
    // this.flgMuestroDrop = (this.field != undefined) ? this.field.visible : true;
  }

  fileBrowseHandler(file: any) {
    [...file].forEach(x => {
      this.archivosSeleccionados.push(x);
    });
  }

  changeType($event: any, file: any) {
    file.tipo = $event.value;
  }

  checkDisableUpload(field:any, file:any){
    let checkD = (field.showExtraFunctions && file.tipo === undefined);
    return checkD !== false;
  }

  delete(file: any) {
    this.archivosSeleccionados = this.archivosSeleccionados.filter(function (item) {
      return item !== file
    })
  }

  async upload(file: any) {
    this.callback(file);
  }

  hidden() {
    return this.field.visible === true;
  }
}
